import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'

export interface QueryParams {
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 排序类型,true-正序，false-倒序 */
  asc?: boolean
  /** 排序字段，默认是device_count */
  sort?: string
  /** 搜索关键字 */
  key_word?: string
}

export interface BlockPortItem {
  /** 阻断规则id */
  rule_id: number
  /** 阻断端口起点 */
  port_start: number
  /** 阻断端口终点 */
  port_end: number
  /** 风险参考（是否已知：0->未知，1->已知） */
  is_known_risk?: number
  /** 风险参考（详情说明） */
  risk_detail?: string
  /** 终端设备数 */
  device_count: number
  /** 系统类型 1-windows 2-linux */
  system_type: number
}

export interface ResetBlockRuleParams {
  /** 选择类型,0-仅指定终端，1-规则下的全部终端 */
  select_type: number
  /** 阻断规则 id 列表（/portcontrol/blocked-rule/cancel 优先使用） */
  rule_id_list: number[]
  /** 终端设备 id 列表 */
  device_list?: string[]
  /** 系统类型 1-windows 2-linux 3-win server 4-mac */
  system_types?: number[]
}

export interface TerQueryParams {
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 终端设备id */
  device_id: string
  /** 排序类型,true-正序，false-倒序 */
  asc?: boolean
  /** 排序字段，默认是device_count */
  sort?: string
}
export interface SingleTerBlockRule {
  /** 阻断规则id */
  rule_id: number
  /** 阻断端口起点 */
  port_start: number
  /** 阻断端口终点 */
  port_end: number
  /** 端口规则 */
  port_protocol: string
  /** 系统类型 1-windows 2-linux 3-win server */
  system_type: number
}
@Injectable()
export class BlockViewService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  @InvokeThrottle()
  getBlockPortRuleList (data: QueryParams) {
    return this.http.post<{
      /** 阻断规则列表 */
      list?: BlockPortItem[]
      /** 总数 */
      total?: number
    }>('/portcontrol/blocked-rule/list', data)
  }

  // 获取指定终端的端口阻断规则列表
  @ParamsClean()
  @InvokeThrottle()
  getSingleTerminalBlockRule (data: TerQueryParams) {
    return this.http.post<{
      /** 终端阻断规则列表 */
      list?: SingleTerBlockRule[]
      /** 总数 */
      total?: number
    }>('/portcontrol/device-blocked-rule/list', data)
  }

  @InvokeThrottle()
  resetBlockRule (data: ResetBlockRuleParams) {
    return this.http.post<void>('/portcontrol/blocked-rule/cancel', data)
  }
}
